





















import { Component, Vue, Prop } from "vue-property-decorator";
import { CalendarBoxConfigCell, CalendarExpandableRow } from "./CalendarTypes";

@Component
export default class CalendarBoxRow extends Vue {
  @Prop() item: CalendarExpandableRow | any;
  @Prop({ required: true }) cell?: CalendarBoxConfigCell;
  @Prop() hideHeader?: boolean;
  @Prop() isNameRow?: boolean;
  @Prop() isMobile?: boolean;
  @Prop() isProperty?: boolean;
}
